/**
 * @file    js/global.js
 *
 * copyright (c) 2006-2014 Frank Hellenkamp [jonas@depage.net]
 *
 * @author    Frank Hellenkamp [jonas@depage.net]
 */

import $ from 'jquery';
import ScrollMagic from 'scrollmagic';
import '@accessible360/accessible-slick';
import './depage-jquery-plugins/depage-analytics';
import './depage-jquery-plugins/depage-email-antispam';
import './depage-jquery-plugins/depage-details';
import './depage-jquery-plugins/depage-player';
import './depage-jquery-plugins/depage-audio';
import './depage-jquery-plugins/depage-live-filter';
import { compile, morph } from 'svg-path-morph';
import { defineCustomElement } from 'vue';
import MapOverview from './components/MapOverview.ce.vue';
import '../sass/global.scss';

export const GutesbadMap = defineCustomElement(MapOverview);
customElements.define('gutesbad-map', GutesbadMap);

var gutesbad = (function() {
    "use strict";
    /*jslint browser: true*/
    /*global $:false */

    var baseUrl = "";
    var lang = $('html').attr('lang');
    var $main, $footer;
    var assetPath;
    var smc = new ScrollMagic.Controller();

    // local Project instance that holds all variables and public functions
    var localJS = {
        // {{{ ready
        ready: function() {
            $("html").addClass("javascript");

            baseUrl = $("head script[src*='/global.js']")[0].src;
            baseUrl = baseUrl.replace(/\/assets\/global(\.*)?\.js.*/, "");
            assetPath = baseUrl + "/js";

            localJS.setup();

            // setup global events
            $(window).on("statechangecomplete", localJS.setup);

            $main = $("main");
            $footer = $("footer");

            $(window).resize(localJS.resize);
            setTimeout(localJS.resize, 200);
        },
        // }}}
        // {{{ setup
        setup: function() {
            localJS.setupVarious();
            localJS.setupNavigation();
            localJS.setupNewsArchive();
            localJS.setupSearch();
            localJS.setupFilter();
            localJS.setupScenes();
            localJS.setupMorph();
            localJS.setupSlideshow();
            localJS.setupHeadlines();
            localJS.setupGlossary();
            localJS.setupPriceCalculator();
            localJS.setupAudio();
            localJS.setupVideos();
            localJS.setupShare();
            localJS.setupMatomoOptout();
        },
        // }}}
        // {{{ setupVarious
        setupVarious: function() {
            var privacyMessage = "We use cookies and similar technologies to understand how you use our services and improve your experience. By clicking 'Accept', you accept all cookies. Otherwise we use only functionally essential cookies. For more information, please see our <a href=\"{$privacyPolicyLink}\">Data Protection Policy</a>";
            if (lang == "de") {
                privacyMessage = "Um unseren Webauftritt für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies. Wenn Sie 'Akzeptieren' klicken, stimmen Sie der Verwendung aller Cookies zu. Andernfalls verwenden wir nur funktional unverzichtbare Cookies. Weitere Informationen, erhalten Sie in unserer <a href=\"{$privacyPolicyLink}\">Datenschutzerklärung für Webseitenbenutzer</a>.";
            }
            $("body").depageAnalytics({
                messageHtml: privacyMessage,
            });

            // add click event for teaser
            $(".teaser, .teaser-click").click( function(e) {
                if (e.isTrigger != 3)  {
                    $("a", this)[0].click();
                }
            });

            $(".details").depageDetails({
                head: "dt",
                speed: 300,
                correctScroll: true,
                scrollOffset: $("header.main").height() + 10
            });
            $(".more-locations").depageDetails({
                head: "h3.opener",
                speed: 300,
            });

            // email antispam
            $("a[href*='mailto:']").depageAntispam();

            // enhance tel-links
            $("a[href^='tel:']").each(function() {
                var target = "call-" + this.href.replace(/[^a-z0-9]*/gi, "");
                var link = this;

                // load in iframe to supress potential errors when protocol is not available
                var $iframe = $("<iframe name=\"" + target + "\" style=\"display: none\" aria-hidden\"true\"></iframe>").appendTo("body");
                link.target = target;
            });
        },
        // }}}
        // {{{ setupNavigation
        setupNavigation: function() {
            var $navSidebar = $("nav.sidebar");
            var $menus = $("nav.sidebar > ul > li");

            $navSidebar.on("click", function() {
                $(this).toggleClass("active");
            });
            $menus.each(function() {
                var $current = $(this);
                var $sub = $current.children("ul");

                if ($sub.length > 0) {
                    var $opener = $("<span class=\"opener\"></span>").appendTo(this);

                    $opener.on("click", function(e) {
                        $menus.filter(".parent-of-active").removeClass("parent-of-active");

                        $current.addClass("parent-of-active");

                        e.stopPropagation();
                    });
                }
            });
        },
        // }}}
        // {{{ setupNewsArchive
        setupNewsArchive: function() {
            var $navArchive = $("nav.archive");

            $navArchive.each(function() {
                var filter = window.location.search;
                var parts = filter.match(/\?filter=(\d+(,\d+)?)/);

                var $links = $(this).find("a[href$='" + filter + "']").addClass("active");
            });
        },
        // }}}
        // {{{ setupSearch
        setupSearch: function() {
            var $search = $("nav.search");
            var $searchInput = $search.find("input");

            $search.on("click", function() {

                if ($search.hasClass("active")) {
                    if ($searchInput.val() != '') {
                        $searchInput.parents("form")[0].submit();
                    }
                    $search.removeClass("active");
                } else {
                    $search.addClass("active");
                    $searchInput.focus();
                }
            });
        },
        // }}}
        // {{{ setupFilter
        setupFilter: function() {
            $(".categories.filter:not(.slick-initialized)").each( function() {
                var $filter = $(this);

                var initial = $filter.find("a.active").parent().index();

                if (window.innerWidth >= 1280) {
                    initial = Math.floor(initial / 8);
                } else if (initial > 0) {
                    initial-= 1;
                }
                if (initial < 0) {
                    initial = 0;
                }

                $filter.slick({
                    slide: "div",
                    arrows: true,
                    autoplay: false,
                    edgeFriction: 0.35,
                    rows: 1,
                    initialSlide: initial,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    variableWidth: true,
                    respondTo: 'slider',
                    responsive: [
                        {
                            breakpoint: 640,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                            }
                        },
                        {
                            breakpoint: 960,
                            settings: {
                                slidesToShow: 6,
                                slidesToScroll: 6,
                            }
                        },
                        {
                            breakpoint: 1280,
                            settings: {
                                slidesToShow: 8,
                                slidesToScroll: 8,
                            }
                        },
                    ],
                });
            });
        },
        // }}}
        // {{{ setupScenes
        setupScenes: function() {
            var smcScenes = [];
            var $newslists= $(".newslist");
            var $navSectionLinks= $("nav.sections a");

            var $navSections = $("nav.sections .inner:not(.slick-initialized)").each( function() {
                $(this).slick({
                    centerMode: true,
                    slide: "div",
                    variableWidth: true,
                    infinite: false,
                    arrows: false,
                    dots: false,
                });
            });

            $navSectionLinks.each(function() {
                $(this).on("click", (e) => {
                    const id = this.hash.substring(1);
                    const el = document.getElementById(id);

                    if (el) {
                        let block = "center";
                        let clientRect = el.getBoundingClientRect();
                        let viewportHeight = window.innerHeight;

                        if (clientRect.height > viewportHeight - 100) {
                            block = "start";
                        }
                        el.scrollIntoView({ behavior: "smooth", block: block, inline: "nearest" });

                        const params = new URLSearchParams(window.location.search);
                        const q = params.size == 0 ? '' : '?';
                        window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}${q}${params}${this.hash}`));

                        return false;
                    }
                });
            });

            var s = new ScrollMagic.Scene({
                    offset: 100,
                })
                .addTo(smc)
                .setClassToggle("body", "scrolled");

            smcScenes.push(s);

            $("#top, section").each(function() {
                var el = this;
                var $el = $(this);
                var id = $el.attr("id");

                var s = new ScrollMagic.Scene({
                        triggerElement: el,
                        duration: function() {
                            return el.offsetHeight;
                        }
                    })
                    .on("enter", function (e) {
                        var index = $navSectionLinks.index($navSectionLinks.filter("[href$='#" + id + "']"));

                        if (index >= 0) {
                            $navSections.slick("slickGoTo", index, true);
                        }
                    })
                    .addTo(smc);

                smcScenes.push(s);
            });
            $(".type-wall01, .type-wall02, .type-vorher-nachher, .full-header .type-slideshow, .full-header.has-image-slides").each(function() {
                var el = this;
                var $el = $(this);
                var $header = $("header.main");
                var hasLightBackground = $el.find(".slide").hasClass("light-image");

                var s = new ScrollMagic.Scene({
                        triggerElement: el,
                        triggerHook: 0,
                        duration: function() {
                            return el.offsetHeight;
                        }
                    })
                    .on("enter", function (e) {
                        $header.toggleClass("light", !hasLightBackground);
                    })
                    .on("leave", function (e) {
                        $header.toggleClass("light", false);
                    })
                    .addTo(smc);

                smcScenes.push(s);
            });
            $(".newslist.style-big .teaser").each(function() {
                var el = this;
                var $el = $(this);
                var st = el.style;

                var s = new ScrollMagic.Scene({
                    triggerElement: el,
                    duration: function() {
                        return el.offsetHeight * 2;
                    },
                    triggerHook: 0.5,
                })
                .on("progress", function(e) {
                    st.setProperty('--sm-progress-sin', Math.sin(e.progress * 1 * Math.PI).toFixed(4));
                })
                .addTo(smc);

                smcScenes.push(s);
            });
            $(".sm-anim").each(function() {
                var el = this;
                var $el = $(this);
                var childTrigger = !$el.hasClass("style-cards");
                var st = el.style;
                var hook = 0.9;
                var pinned = $el.hasClass("pinned");
                if ($el.is(":last-child")) {
                    hook = 0.95;
                }
                if (pinned) {
                    hook = 0;
                }

                var s = new ScrollMagic.Scene({
                        triggerElement: el,
                        triggerHook: hook
                    })
                    .addTo(smc)
                    .setClassToggle(el, "in-view");

                smcScenes.push(s);

                var navTags = [
                    "tag_Inspiration",
                    "tag_Analyse",
                    "tag_Badplanung",
                    "tag_Produkte",
                    "tag_Realisierung",
                ];

                navTags.forEach(function(value, i, array) {
                    if ($newslists.length <= 1) {
                        return;
                    } 
                    if ($el[0] != $newslists[i]) {
                        return;
                    }
                    var $elToggle = $("nav.main li." + value);
                    if ($elToggle.length == 0) {
                        return;
                    }

                    var s = new ScrollMagic.Scene({
                            triggerElement: el,
                            duration: "100%"
                        })
                        .addTo(smc)
                        .setClassToggle($elToggle[0], "in-view");

                    smcScenes.push(s);
                });

                // {{{ bloglists
                $el.find(".sm-anim-child").each(function(i) {
                    var sub = this;
                    var triggerEl = el;
                    var off = (-30 + 50 * i) + "%";

                    if (childTrigger) {
                        triggerEl = sub;
                        off = 0;
                    }

                    var s = new ScrollMagic.Scene({
                            triggerElement: triggerEl,
                            triggerHook: 0.8,
                            offset: off
                        })
                        .setClassToggle(sub, "in-view")
                        .addTo(smc);

                    smcScenes.push(s);
                });
                // }}}
                // {{{ animatedElements
                $el.find(".slide").each(function(i) {
                    var sub = this;
                    var st = sub.style;
                    var off = -200;
                    var hook = 0.5;
                    var duration = "25%";

                    if ($(sub).parent().hasClass("animation-columns")) {
                        off += 200 * i;
                    } else if ($(sub).parent().hasClass("animation-poppy")) {
                        hook = 0.75;
                        duration = "100%";
                    }

                    var s = new ScrollMagic.Scene({
                            triggerElement: sub,
                            triggerHook: hook,
                            offset: off,
                            duration: duration
                        })
                        .setClassToggle(sub, "in-view")
                        .on("progress", function(e) {
                            st.setProperty('--sm-progress-cos', Math.cos((e.progress) * 1 * Math.PI).toFixed(4));
                        })
                        .addTo(smc);

                    smcScenes.push(s);
                });
                // }}}
            });
        },
        // }}}
        // {{{ setupMorph
        setupMorph: function() {
            let paths = [];
            let percent = 0;
            let masks = document.querySelectorAll(".flowy-mask-animated path");
            let flowy = document.querySelectorAll(".newslist.style-flowy");
            if (masks.length == 0 || flowy.length == 0) {
                return;
            }

            document.querySelectorAll(".morph-path").forEach(function(el) {
                paths.push(el.getAttribute("d"));
            });
            const compiled = compile(paths);
            const dist = (x1, y1, x2, y2) => {
                return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2))
            };
            const clamp = (value, min, max) => {
                return Math.min(Math.max(value, min), max)
            };

            requestAnimationFrame(function loop() {
                masks.forEach(function(el, n) {
                    let weights = [];

                    // calculate masks.lengths weights, always centered around the nth item
                    // so that the nth item is always fully visible
                    // and the items before and after are falling off to zero
                    // and lopped back to first item after the last item
                    // so that the morphing is always smooth
                    for (let i = 0; i < masks.length; i++) {
                        let pos = i + n + percent;
                        let weight = pos % masks.length;

                        if (weight > 2) {
                            weight = 0;
                        } else if (weight > 1) {
                            weight = 2 - weight;
                        } else {
                            weight = weight;
                        }

                        weights[i] = weight;
                    }

                    const morphed = morph(compiled, weights);
                    el.setAttribute("d", morphed);
                });
                percent += 0.005;

                requestAnimationFrame(loop);
            });
        },
        // }}}
        // {{{ setupHeadlines
        setupHeadlines: function() {
            const tolerance = 20;

            $("h1.bubble, h3.bubble, .head.bubble").each(function() {
                var $h = $(this);
                var $h1 = $h.find(".first-word");
                var $h2 = $h.find(".other-words");

                var h1Width = $h1.outerWidth();
                var h2Width = $h2.outerWidth();
                $h[0].style.setProperty('--hmin-width', "0px");

                setTimeout(function() {
                    if (Math.abs(h1Width - h2Width) < tolerance) {
                        $h[0].style.setProperty('--hmin-width', Math.max(h1Width, h2Width) + "px");

                        $h1.removeClass("is-longer");
                        $h2.removeClass("is-longer");

                    } else {
                        $h1.toggleClass("is-longer", h1Width > h2Width);
                        $h2.toggleClass("is-longer", h2Width > h1Width);
                    }
                }, 10);
            });
        },
        // }}}
        // {{{ setupGlossary
        setupGlossary: function() {
            var $columns = $(".glossary-columns");

            $("article.glossary")
                .on("depage.filter-shown", function(e, $item) {
                    $item.removeClass("hidden");
                })
                .on("depage.filter-hidden", function(e, $item) {
                    $item.addClass("hidden");
                });

            $("#Glossar")
                .depageLiveFilter("article.glossary", "*", {
                    placeholder: "Suchbegriff eingeben...",
                })
                .on("depage.filter-updated", function(e, visible, total) {
                    $columns.each(function() {
                        var $visibleItems = $(this).find("article.glossary:not(.hidden)");
                        var visible = $visibleItems.length > 0;
                        var char = $(this).find("h2").first().text().charAt(0).toUpperCase();

                        $(this).toggle(visible);

                        if (visible) {
                            $(".to-" + char).removeClass("disabled");
                        } else {
                            $(".to-" + char).addClass("disabled");
                        }
                    });
                });

            $(".depage-live-filter").insertAfter("nav.alphabet.inline" );
        },
        // }}}
        // {{{ setupSlideshow
        setupSlideshow: function() {
            var $slideshows = $(".type-slideshow:not(.slick-initialized)").each( function() {
                var $slideshow = $(this);

                $slideshow.slick({
                    dots: true,
                    arrows: true,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    useAutoplayToggleButton: false,
                    pauseOnDotsHover: true,
                    pauseOnFocus: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    variableWidth: true,
                    //fade: true,
                });
            });

            var $flowy = $(".style-flowy > .inner:not(.slick-initialized)").each( function() {
                var $flowy = $(this);
                var $teasers = $flowy.children(".teaser").each(function(i) {
                    $(this).addClass("teaser-" + (i + 1));
                });

                $flowy.slick({
                    dots: true,
                    arrows: true,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    pauseOnDotsHover: true,
                    useAutoplayToggleButton: false,
                    slidesToShow: 1,
                    centerMode: true,
                    slidesToScroll: 1,
                    infinite: true,
                    variableWidth: true,
                });
            });

            var $wall = $(".type-wall01, .type-vorher-nachher").each( function() {
                var $wall = $(this);
                var $slides = $wall.children(".slide");
                var currentActive = -1;
                var nextSlideTimer = null;
                var setActiveSlide = function(active) {
                    var $slide = $slides.eq(active);
                    var className = "active-" + (active + 1);
                    var removeClass = ["active", "active-" + (currentActive + 1)];

                    $wall.removeClass(removeClass);
                    $slides.eq(currentActive).removeClass("active");

                    if (currentActive != active) {
                        $wall.addClass(className).addClass("active");
                        $slide.addClass("active");

                        currentActive = active;
                    } else {
                        currentActive = -1;
                    }
                };
                var nextSlide = function() {
                    var active = currentActive + 1;

                    if (active >= $slides.length) {
                        active = 0;
                    }
                    setActiveSlide(active);
                    clearTimeout(nextSlideTimer);
                    nextSlideTimer = setTimeout(nextSlide, 5000);
                };
                var prevSlide = function() {
                    var active = currentActive - 1;

                    if (active < 0) {
                        active = $slides.length - 1;
                    }
                    setActiveSlide(active);
                    clearTimeout(nextSlideTimer);
                    nextSlideTimer = setTimeout(prevSlide, 5000);
                };

                $slides.each( function(i) {
                    var $slide = $(this);

                    $slide.on("click", function() {
                        clearTimeout(nextSlideTimer);
                        setActiveSlide(i);
                    });
                });

                if ($wall.hasClass("type-vorher-nachher")) return;
                
                if ($slides.length < 2) return;

                var $nextButton = $("<button class='slick-next slick-arrow' type='button' aria-label='Next' role='button'>Next</button>")
                    .on("click", nextSlide)
                    .appendTo($wall);

                var $prevButton = $("<button class='slick-prev slick-arrow' type='button' aria-label='Previous' role='button'>Previous</button>")
                    .on("click", prevSlide)
                    .appendTo($wall);

                if ($wall.is("article > header.full-header:first-child .fullsize")) {
                    // only autopley the first wall element
                    nextSlideTimer = setTimeout(nextSlide, 5000);
                }
            });

            var $newswall = $(".newslist.style-wall .inner").each( function() {
                var $wall = $(this);
                var $slides = $wall.children(".teaser");
                var num = 7;
                var current = 0;

                var updateActive = function() {
                    $slides.each( function(i) {
                        $(this).toggleClass("active", i >= current && i < current + num || i <= current - $slides.length + num - 1);
                    });

                    current++;
                    if (current % $slides.length == 0) {
                        current = 0;
                    }
                };

                updateActive();
                setInterval(updateActive, 5000);
            });
        },
        // }}}
        // {{{ setupPriceCalculator
        setupPriceCalculator: async function() {
            const priceCalculator = document.querySelector('.price-calculator');

            if (!priceCalculator) {
                return;
            }

            // Get styles from the imported sheet, extracts their CSS as text.
            let rulesCSSText = await fetch(baseUrl + '/assets/pricecalculator.css');
            rulesCSSText = await rulesCSSText.text();
            
            // Your custom element, nested (if you want).
            const shadowRoot = priceCalculator.shadowRoot;

            var sheet = new CSSStyleSheet();
            sheet.replaceSync(rulesCSSText);
            shadowRoot.adoptedStyleSheets.push(sheet);
        },
        // }}}
        // {{{ setupAudio
        setupAudio: function() {
            $(".audio").each(function() {
                var $audio = $(this);

                $audio.depageAudio({
                    assetPath: "lib/global/images/",
                    imageSuffix: ".svg",
                    onEnd: function() {
                    },
                    onPause: function() {
                    },
                    onPlay: function() {
                    }
                });
            });
        },
        // }}}
        // {{{ setupVideos
        setupVideos: function() {
            $(".video").each( function() {
                var $video = $(this);

                $video.depagePlayer({
                    crop: false,
                    constrain: false,
                    assetPath: "lib/global/images/",
                    onPlay: function() {
                        $video.find(".controls").show();
                    }
                });
            });
        },
        // }}}
        // {{{ setupShare
        setupShare: function() {
            if (!navigator.canShare) {
                return;
            }

            var $share = $("<button class=\"share\" title=\"Teilen\">Teilen</button>");

            $share.on('click', function() {
                let shareData = {
                    title: document.title,
                    text: document.title,
                    url: location.href
                }

                navigator.share(shareData).then(() => {
                    console.log("shared");
                })
                .catch((e) => {
                    console.log('error: ' + e)
                });
            });

            $share.clone(true).appendTo(".share-container");
        },
        // }}}
        // {{{ setupMatomoOptout
        setupMatomoOptout: function() {
            /*
https://analytics.depage.net/index.php?module=CoreAdminHome&action=optOut&language=de&backgroundColor=ffffff&fontColor=646464&fontSize=0.9em&fontFamily=%22Helvetica%20Neue%22%2C%20%22Arial%22%2C%20%22Helvetica%22%2C%20Sans-Serif
https://analytics.depage.net/index.php?module=CoreAdminHome&action=optOut&language=en&backgroundColor=ffffff&fontColor=646464&fontSize=0.9em&fontFamily=%22Helvetica%20Neue%22%2C%20%22Arial%22%2C%20%22Helvetica%22%2C%20Sans-Serif
             */
            $("a[href^=\"https://analytics.depage.net/index.php?module=CoreAdminHome&action=optOut\"]").each(function() {
                var $iframe = $("<iframe></iframe>");
                $iframe.attr("class", "matomo");
                $iframe.attr("src", this.href);

                $iframe.insertAfter(this);
                $(this).hide();
            });
        },
        // }}}

        // {{{ resize
        resize: function() {
            $main.height("auto");

            localJS.setupHeadlines();
        }
        // }}}
    };

    return localJS;
})();

// {{{ register ready event
$(document).ready(function() {
    gutesbad.ready();
});
// }}}

// vim:set ft=javascript sw=4 sts=4 fdm=marker :
